import React from "react";
import moment from "moment";
import styles from "./ArrivedDisplayer.css";
import ChevronDown from "../../images/ic-chevron-down.svg";

interface Props {
  arrivalTime: number;
  onClickChevronDown: () => void;
}

export const ArrivedDisplayer = ({
  arrivalTime,
  onClickChevronDown
}: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.containerText}>
        <div className={styles.containerTime}>
          <div className={styles.time}>
            {moment(arrivalTime).format("HH:mm")}
          </div>
          hora aproximada
        </div>
      </div>

      <div className={styles.chevronDownContainer}>
        <ChevronDown
          onClick={onClickChevronDown}
          className={styles.chevronDown}
        />
      </div>
    </div>
  );
};
